module.exports = __webpack_public_path__ + "src/assets/games/10/73.jpg";